import axios from 'axios'
import store from '../store/index'
import msalInstance from '../auth/msalInstance'
import { loginRequest } from '../auth/msalConfig'

const jwtInterceptor = axios.create({ baseURL: '/api' })

// Shared promise prevents multiple simultaneous token-acquisition calls
let _refreshPromise = null

async function _acquireToken() {
  if (_refreshPromise) return _refreshPromise
  const accounts = msalInstance.getAllAccounts()
  if (!accounts.length) return null
  _refreshPromise = msalInstance
    .acquireTokenSilent({ ...loginRequest, account: accounts[0] })
    .then(result => {
      store.commit('SET_ID_TOKEN', result.idToken)
      return result.idToken
    })
    .catch(() => {
      store.commit('CLEAR_AUTH')
      return null
    })
    .finally(() => { _refreshPromise = null })
  return _refreshPromise
}

jwtInterceptor.interceptors.request.use(async (config) => {
  let idToken = store.getters.idToken
  if (!idToken) {
    idToken = await _acquireToken()
  }
  if (idToken) {
    config.headers['Authorization'] = `Bearer ${idToken}`
  }
  return config
})

jwtInterceptor.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401 && !error.config._retried) {
      error.config._retried = true
      store.commit('SET_ID_TOKEN', null)
      const idToken = await _acquireToken()
      if (idToken) {
        error.config.headers['Authorization'] = `Bearer ${idToken}`
        return jwtInterceptor(error.config)
      }
    }
    return Promise.reject(error)
  }
)

export default jwtInterceptor
